import { QueryClientProvider } from '@tanstack/react-query'
import { App as AntApp, ConfigProvider } from 'antd'
import viVN from 'antd/locale/vi_VN'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { AuthProvider } from './auth/AuthContext'
import { createQueryClient } from './queryClient'
import { routes } from './routes'

const queryClient = createQueryClient()
const router = createBrowserRouter(routes)

export function App() {
  return (
    <ConfigProvider locale={viVN} theme={{ token: { colorPrimary: '#1f6feb' } }}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  )
}
